import React, { useState, useEffect, useRef, useContext } from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { ApiService } from "../../Components/Services/apiservices";
import constants from "../../Components/Services/constant";
import DataContext from "../../Components/Elements/eventContext";

function Contact() {
  let apiServices = new ApiService();
  const contextValues = useContext(DataContext);
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Subject, setSubject] = useState("");
  const [Message, setMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [settingData, setSettingData] = useState({});
  const didMountRef = useRef(true);
  const [pageData, setPageData] = useState({});

  useEffect(() => {
    if (didMountRef.current) {
      apiServices.settingsdataGetRequest().then((res) => {
        if (res.data && res.data.status === "success") {
          contextValues.setImageUrl(res.data.settings_url);
          contextValues.setSettingData(res.data.sitesettings);
          setSettingData(res.data.sitesettings);
        }
      });
      const dataString = { page_url: "contact" };
      apiServices.pagePostRequest(dataString).then((res) => {
        if (res.data && res.data.status === "success" && res.data.pageData) {
          setPageData(res.data.pageData);
        }
      });
    }
    didMountRef.current = false;
  }, []);

  const submitmessage = (e) => {
    e.preventDefault();
    if (Name && Email && Mobile && Subject && Message) {
      setLoading(true);
      const dataString = {
        name: Name,
        email: Email,
        mobile: Mobile,
        subject: Subject,
        message: Message,
      };

      apiServices
        .contactRequest(dataString)
        .then((res) => {
          if (res.data.status === "success") {
            setSuccessMessage(res.data.message);
            setName("");
            setEmail("");
            setMobile("");
            setSubject("");
            setMessage("");
            seterrorMessage("");
          } else {
            seterrorMessage(res.data.message || "An error occurred");
            setSuccessMessage("");
          }
        })
        .catch((err) => {
          seterrorMessage("Failed to send message. Please try again.");
          setSuccessMessage("");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      seterrorMessage("Please fill out all required fields.");
      setSuccessMessage("");
    }
  };

  return (
    <>
      <Header />
      <style>
        {`
            .contact-banner-responsive {
                background-image: url('${pageData?.page_header_image ? `${constants.IMAGE_URL}${pageData.page_header_image}` : "/assets/img/food/Contact-us-Desktop.webp"}');
            }
            @media (max-width: 768px) {
                .contact-banner-responsive {
                    background-image: url('${pageData?.metadata?.banner_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.banner_mobile_image}` : "/assets/img/food/Contact-US-Mobile.webp"}');
                }
            }
        `}
      </style>
      <div
        className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed contact-banner-responsive"
        data-overlay-dark="3"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "100%",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center caption mt-90">
              <h1 dangerouslySetInnerHTML={{ __html: pageData?.metadata?.page_title || "Contact Us" }} />
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "50px", backgroundColor: "#0b0c0b" }}>
        <section className="contact mt-20">
          <div className="container">
            <div className="row mb-90">
              <div className="col-md-5 mb-30">
                <h3>
                  <b>Chokhi Dhani London</b>
                </h3>
                <p
                  className="mb-30"
                  style={{ textAlign: "justify", fontSize: "16px" }}
                >
                  {pageData?.metadata?.page_desc || "Bringing the rich heritage of Rajasthan to London. Experience our handcrafted interiors, authentic cuisine, and warm hospitality."}
                </p>
                <div className="reservations mb-30">
                  <div className="icon">
                    <span className="flaticon-call"></span>
                  </div>
                  <div className="text">
                    <p>Reservation</p>
                    <a
                      href={"tel:" + settingData.admin_support_mobile}
                      className="footer-contact-phone"
                    >
                      {settingData.admin_support_mobile}
                    </a>
                    <br />
                    <a
                      href={"tel:" + settingData.admin_mobile}
                      className="footer-contact-phone"
                    >
                      {settingData.admin_mobile}
                    </a>
                  </div>
                </div>
                <div className="reservations mb-30">
                  <div className="icon">
                    <span className="flaticon-envelope"></span>
                  </div>
                  <div className="text">
                    <p>Email Info</p>
                    <a href={"mailto:" + settingData.admin_email}>
                      {settingData.admin_email}
                    </a>
                  </div>
                </div>
                <div className="reservations mb-30">
                  <div className="icon">
                    <span className="flaticon-location-pin"></span>
                  </div>
                  <div className="text">
                    <p>Address</p>
                    <a
                      href="https://goo.gl/maps/U4in9GLkcYvvayJn8"
                      target="new"
                    >
                      {settingData.address}
                      <br />
                    </a>
                  </div>
                </div>
                <div>
                  <h3>
                    <b>Travel Notes</b>
                  </h3>
                  {settingData?.travel_notes || pageData?.metadata?.travel_notes ? (
                    <div dangerouslySetInnerHTML={{ __html: settingData?.travel_notes || pageData?.metadata?.travel_notes }} />
                  ) : (
                  <p>
                    The nearest tube station is Vauxhall (Victoria Line) / Battersea Power Station (Northern Line). From Vauxhall Station (Stop E), you can either get a 156/344/436 bus. Alternatively, you could walk to the venue. A walking distance of 15 minutes along the river from Vauxhall Station and a 5 minutes walk from Battersea Power Station.
                  </p>
                  )}
                </div>
              </div>
              <div className="col-md-5 mb-30 offset-md-1">
                <div className="booking-box" style={{ marginBottom: 0 }}>
                  <div className="head-box">
                  </div>
                  <div
                    className="booking-inner clearfix"
                    id="showbookingboxcontact01"
                  ></div>
                  <div
                    id="showbookingboxcontact"
                    className="mcbooking"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-60">
              <div className="col-lg-8 col-md-10 text-center">
                <h3>
                  <b>Get in touch</b>
                </h3>
                {successMessage != "" ? (
                  <div className="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                ) : (
                  ""
                )}
                {errorMessage != "" ? (
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                ) : (
                  ""
                )}

                <form method="post" className="contact__form text-start">
                  <div className="row">
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-name"
                        id="contact-name"
                        type="text"
                        placeholder="Your Name *"
                        onChange={(e) => setName(e.target.value)}
                        value={Name}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-email"
                        id="contact-email"
                        type="email"
                        placeholder="Your Email *"
                        onChange={(e) => setEmail(e.target.value)}
                        value={Email}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-phone"
                        id="contact-phone"
                        type="number"
                        placeholder="Your Number *"
                        onChange={(e) => setMobile(e.target.value)}
                        value={Mobile}
                        required
                        style={{ color: "#666" }}
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <input
                        name="contact-subject"
                        id="contact-subject"
                        type="text"
                        placeholder="Subject *"
                        onChange={(e) => setSubject(e.target.value)}
                        value={Subject}
                        required
                      />
                    </div>
                    <div className="col-md-12 form-group mb-3">
                      <textarea
                        name="contact-message"
                        id="contact-message"
                        cols="30"
                        rows="4"
                        placeholder="Message *"
                        onChange={(e) => setMessage(e.target.value)}
                        value={Message}
                        required
                      ></textarea>
                    </div>

                    <div className="col-md-12 text-center">
                      <button
                        type="submit"
                        className="butn-dark2"
                        name="submit"
                        onClick={submitmessage}
                        disabled={loading}
                      >
                        <span>
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Sending...
                            </>
                          ) : (
                            "Send Message"
                          )}
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="row">
              <div
                className="col-md-12 map animate-box"
                data-animate-effect="fadeInUp"
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.691480713622!2d-0.13951412426024903!3d51.48217711254672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604fce8206467%3A0x6801d6ed861bf425!2sChokhi%20Dhani!5e0!3m2!1sen!2sin!4v1681897927270!5m2!1sen!2sin"
                  width={"100%"}
                  height={"600"}
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading={"lazy"}
                ></iframe>
              </div>
            </div>
          </div>
        </section>


      </div>

      <Footer />
    </>
  );
}

export default Contact;
